package dev.wyns.ventrova

import dev.wyns.ventrova.data.PlaceRepository
import dev.wyns.ventrova.platform.ExternalActions
import dev.wyns.ventrova.platform.KeyValueStore
import dev.wyns.ventrova.platform.SuggestionService

/** Platform-specific implementations, created by each platform's entry point. */
class AppDependencies(
    val placeRepository: PlaceRepository,
    val keyValueStore: KeyValueStore,
    val externalActions: ExternalActions,
    val suggestionService: SuggestionService,
)
